<template>
  <div class="map-section">
    <div class="map-section__header">
      <q-btn color="primary" icon-right="more_vert" label="Действие" size="md" padding="sm"
        class="map-section__header-btn">
        <q-popup-proxy ref="actionPopup">
          <q-banner class="action-popup">
            <div class="action-popup__header">
              <p class="action-popup__title">Действия</p>
              <q-icon name="close" size="16px" class="action-popup__close" @click="$refs.actionPopup.hide()" />
            </div>
            <div class="action-popup__content">
              <CustomButton color="primary-light" size="md" @click="onLoadRevitData">
                Загрузить данные Revit
              </CustomButton>
              <div v-if="isRevit && selectedBufferParamsType?.selectedData?.length > 0"
                class="action-popup__param-select">
                <CustomSelect :options="paramTypeOptions" label="Тип параметра" optionValueKey="value"
                  optionLabelKey="label" :value="selectedParamType" @change="onParamTypeChange" :full-width="true" />
              </div>
              <q-btn :disable="!selectedParamType" v-show="selectedParamType && isRevit" color="blue" size="md"
                @click="onUpdateSubmit" class="map-section__header-btn map-section__header-btn--update">
                Обновить тип стены
              </q-btn>
              <q-btn color="red" size="md" @click="onDeleteClick"
                class="map-section__header-btn map-section__header-btn--delete"
                :disable="!selectedBufferParamsType?.selectedData?.length">
                Удалить
              </q-btn>
            </div>
          </q-banner>
        </q-popup-proxy>
      </q-btn>
      <q-btn size="md" class="map-section__header-btn map-section__header-btn--refresh" @click="refreshData">
        Обновить данные
        <img src="/img/icons/rotate.svg" class="map-section__header-icon" />
      </q-btn>
      <q-btn size="md" class="map-section__header-btn map-section__header-btn--lines" @click="toggleSchema">
        Показать линии
        <img src="/img/icons/lines.svg" class="map-section__header-icon" />
      </q-btn>
    </div>
    <div class="map-section__content">
      <div class="map-section__content-item">
        <div class="buffer-schema-view" v-if="showSchema">
          <div class="buffer-schema-view__controls">
            <q-btn size="sm" class="buffer-schema-view__control-btn map-section__content-item-zoom-in-btn"
              @click="zoomIn">
              <q-icon name="add" />
            </q-btn>
            <q-btn size="sm" class="buffer-schema-view__control-btn map-section__content-item-zoom-out-btn"
              @click="zoomOut">
              <q-icon name="remove" />
            </q-btn>
            <q-btn size="sm" class="buffer-schema-view__control-btn map-section__content-item-rotate-btn"
              @click="rotateSchema">
              <q-icon name="refresh" />
            </q-btn>
          </div>

          <div class="buffer-schema-view__content" ref="schemaContainer">
            <div v-if="bufferParams">
              <Schema :bufferParams="bufferParams" ref="schemaComponent" :containerWidth="containerWidth"
                :containerHeight="containerHeight" :rotationAngle="rotationAngle" :isRevit="isRevit" />
            </div>
            <div v-else class="no-data-placeholder">
              <q-icon name="info" size="48px" color="grey-6" />
              <p>Выберите элементы для отображения</p>
            </div>
          </div>
        </div>
        <div v-else class="no-data-placeholder">
          <q-icon name="info" size="48px" color="grey-6" />
          <p>Нажмите "Показать линий" для отображения схемы</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import Schema from "@/views/BufferParams/Schema.vue";
import PopupConfirm from "@/components/common/PopupConfirm";
import CustomSelect from "@/components/form/CustomSelect";
import { deleteBufferParams, updateBufferParams, deleteRevitBufferParams } from "@/views/BufferParams/services"
import { getParamType } from "@/views/RevitBufferParams/services"
import CustomButton from "@/components/common/CustomButton.vue";
import { useAppStore } from "@/services/store/app";
import { MODAL_NAMES } from "@/constants";
import { uploadRevitJson } from "@/views/RevitBufferParams/services";

export default {
  name: "BufferSchemaView",
  components: { PopupConfirm, Schema, CustomSelect, CustomButton },
  props: {
    bufferParams: {
      type: Object,
      default: null
    },
    selectedBufferParamsType: {
      type: Object,
      default: null
    },
    savedFilters: {},
    rowsData: {
      type: Array,
      default: () => []
    },
    isRevit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showSchema: false,
      rotationAngle: 0,
      containerWidth: 450,
      containerHeight: 450,
      deleting: false,
      updating: false,
      paramTypeOptions: [],
      selectedParamType: null,
    };
  },
  mounted() {
    this.updateContainerSize();
    window.addEventListener('resize', this.updateContainerSize);
    this.loadParamTypes();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateContainerSize);
  },
  methods: {
    async onLoadRevitData() {
      this.showModal(MODAL_NAMES.AddRevitData, {
        onSubmit: this.onLoadRevitDataSubmit,
        title: 'Загрузить данные Revit',
      });
    },
    async onLoadRevitDataSubmit(body) {
      const res = await uploadRevitJson(body);
      if (!res) return;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async onUpdateSubmit() {
      const ids = this.selectedBufferParamsType.selectedData.map(item => item.floor_buffer_id);
      if (this.updating || !ids.length) return;
      this.updating = true;
      const res = await updateBufferParams(ids, this.selectedParamType, this.savedFilters);
      this.updating = false;
      if (!res) return;
      this.showSucceedSnackbar();
      this.$emit('update-rows', res);
      this.$refs.actionPopup.hide();
    },
    async loadParamTypes() {
      const res = await getParamType();
      this.paramTypeOptions = res || [];
    },
    onParamTypeChange(value) {
      this.selectedParamType = value;
    },
    onDeleteClick() {
      let ids = [];
      if (this.isRevit) {
        ids = this.bufferParams?.polygons.map(item => item.floor_buffer_id);
      } else {
        ids = [
          ...(this.bufferParams?.lines || []),
          ...(this.bufferParams?.circles || []),
        ].map(item => item.floor_buffer_id);
      }
      this.onDeleteSubmit(ids);
      this.$refs.actionPopup.hide();
    },
    async onDeleteSubmit(ids) {
      if (this.deleting || !ids.length) return;

      this.deleting = true;
      let res;
      if (this.isRevit) {
        res = await deleteRevitBufferParams(ids, this.savedFilters);
      } else {
        res = await deleteBufferParams(ids, this.savedFilters);
      }
      this.deleting = false;
      if (!res) return;
      this.$emit('update-rows', res);
      this.showSucceedSnackbar();
    },
    refreshData() {
      this.$emit('refresh-data');
    },
    toggleSchema() {
      this.showSchema = !this.showSchema;
      if (this.showSchema) {
        this.$nextTick(() => {
          this.updateContainerSize();
        });
      }
    },
    getStage() {
      return this.$refs.schemaComponent?.$refs?.stage?.getNode();
    },
    zoomIn() {
      const stage = this.getStage();
      if (!stage) return;

      const scaleBy = 1.2;
      const oldScale = stage.scaleX();
      const newScale = oldScale * scaleBy;

      const center = {
        x: stage.width() / 2,
        y: stage.height() / 2
      };

      this.zoomToPoint(stage, center, newScale);
    },
    zoomOut() {
      const stage = this.getStage();
      if (!stage) return;

      const scaleBy = 1.2;
      const oldScale = stage.scaleX();
      const newScale = oldScale / scaleBy;

      const center = {
        x: stage.width() / 2,
        y: stage.height() / 2
      };

      this.zoomToPoint(stage, center, newScale);
    },
    rotateSchema() {
      this.rotationAngle += 90;
      this.rotationAngle = this.rotationAngle % 360;

      this.$nextTick(() => {
        const schemaComponent = this.$refs.schemaComponent;
        if (schemaComponent && schemaComponent.centerAndRotate) {
          schemaComponent.centerAndRotate();
        }
      });
    },
    zoomToPoint(stage, point, newScale) {
      const oldScale = stage.scaleX();

      const mousePointTo = {
        x: (point.x - stage.x()) / oldScale,
        y: (point.y - stage.y()) / oldScale,
      };

      stage.scale({ x: newScale, y: newScale });

      const newPos = {
        x: point.x - mousePointTo.x * newScale,
        y: point.y - mousePointTo.y * newScale,
      };

      stage.position(newPos);
      stage.batchDraw();
    },
    updateContainerSize() {
      const container = this.$refs.schemaContainer;
      if (container) {
        this.containerWidth = container.offsetWidth;
        this.containerHeight = container.offsetHeight;
      }
    }
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    const { showModal, closeModal } = useAppStore();
    return { showSucceedSnackbar, showModal, closeModal };
  },
};
</script>

<style scoped lang="scss">
.map-section {
  width: 40%;
  flex: 0 0 40%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.map-section__header {
  display: flex;
  justify-content: end;
  gap: 16px;
}

.map-section__header-icon {
  width: 12px;
  height: 12px;
}

.map-section__header-btn {
  padding: 7px 12px;
  height: 46px;
  border-radius: 8px;
  font-weight: 400;
  color: #FFFFFF;
  text-transform: none;

  &:before {
    box-shadow: none !important;
  }

  :deep(.q-icon) {
    width: 12px;
    height: 12px;
    font-size: 16px;
  }

  :deep(.q-btn__content) {
    font-size: 13px;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }

  &--refresh {
    background-color: #FFAC5E;
  }

  &--lines {
    background-color: #0060FE;
  }
}

.map-section__content-item-zoom-in-btn,
.map-section__content-item-zoom-out-btn,
.map-section__content-item-rotate-btn {
  z-index: 1000;
  width: 34px;
  height: 34px;
  position: absolute;
  top: 18px;
  border-radius: 8px;
  padding: 13px 7px;
  background-color: #F2F5F8;

  &:before {
    box-shadow: none !important;
  }

  :deep() {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}

.map-section__content-item-zoom-in-btn {
  right: 84px;
}

.map-section__content-item-zoom-out-btn {
  right: 126px;
}

.map-section__content-item-rotate-btn {
  right: 18px;
}

.map-section__content-item {
  position: relative;
  width: 100%;
  min-height: 450px;
  border-radius: 8px;
  border: 1px solid #D1D5DB;
}

.buffer-schema-view {
  position: relative;
  width: 100%;
  height: 450px;
  max-height: 450px;
  border-radius: 8px;
  border: 1px solid #D1D5DB;
  overflow: hidden;
}

.buffer-schema-view__controls {
  display: flex;
  gap: 8px;
}

.buffer-schema-view__control-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  padding: 13px 7px;
  background-color: #F2F5F8;
  border: 1px solid #D1D5DB;

  :deep() {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  &:hover {
    background-color: #E5E7EB;
  }
}

.buffer-schema-view__content {
  width: 100%;
  height: 100%;
  position: relative;
}

.no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 450px;
  height: 100%;
  color: #6c757d;
  text-align: center;
}

.action-popup {
  border-radius: 8px;
  padding: 7px 12px;
  min-width: 200px;
  max-width: 300px;

  .action-popup__content-title {
    font-size: 13px;
    color: #374151;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 0;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 14px;
    color: #374151;
  }

  &__close {
    cursor: pointer;
    color: #6B7280;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__param-select {
    margin-bottom: 12px;
  }
}
</style>
